export default function () {
	return {
		activities: [],
		activities_menu: [],
		hierarchy_order: null,
		id: null,
		loading: false,
		block_activities_menu: false,
	}
}
